import { convertToFahrenheit, convertToInches } from "./convertUnits";
import { prepareNumber } from "./prepareNumber";
//const intl = useIntl();

const unitMessages: any = {
    perc: ["%", 0],
    hrs: ["hour", 0, true],
    day: ["day", 0, true],
    hpa: ["hpa", 0],
    ms: ["m/s", 0]

    //'hrs': [intl.formatMessage({ id: 'common.units.hours' }),1],
    //'day': [intl.formatMessage({ id: 'common.units.days' }),1]
};

export default ({
    text,
    units,
    noNbsp
}: {
    text: string;
    units: string;
    noNbsp?: boolean;
}) => {
    let splitted = text.split("@@");
    let final = "";
    const space = noNbsp ? " " : "\u00A0";
    for (let part of splitted) {
        let detailSplitted = part.split("#");
        if (detailSplitted.length < 2) {
            final += part;
            continue;
        }
        let [textVal, unit, precision] = detailSplitted;
        const precisionValue = parseInt(precision || "0");
        let val = parseFloat(textVal);
        if (unitMessages[unit]) {
            let [unitText, fixed, addPlural] = unitMessages[unit];
            fixed = precisionValue ?? fixed;
            const num = prepareNumber(val, fixed);
            unitText += (!addPlural || num=="1") ? "" : "s"
            final += `${num}${space}${unitText}`;
            continue;
        }

        if (unit === "deg") {
            const fixed = precisionValue ?? 1;
            let valCelsius = `${prepareNumber(val, fixed)}${space}°C`;
            let valFahrenheit = `${prepareNumber(
                convertToFahrenheit(val), fixed
                
            )}${space}°F`;
            final +=
                units == "C"
                    ? `${valCelsius}${space}(${valFahrenheit})`
                    : `${valFahrenheit}${space}(${valCelsius})`;
        } else if (unit === "mm") {
            let valMm = `${prepareNumber(val, 0)}${space}mm`;
            let valInches = `${prepareNumber(
                convertToInches(val),
                2
            )}${space}in`;
            final +=
                units == "C"
                    ? `${valMm}${space}(${valInches})`
                    : `${valInches}${space}(${valMm})`;
        } else if (unit === "nounit" || unit === "wi" || !unitMessages[unit]) {
            final += prepareNumber(val, precisionValue ?? 1);
        }
    }
    return final;
};
